/** QPN-2066 — schedule + launch type (schema v2 §8) */

const LaunchType = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  MANUAL: 'MANUAL',
  COMPLETE: 'COMPLETE',
});

/** UI label for LaunchType.COMPLETE */
const LaunchTypeLabel = Object.freeze({
  [LaunchType.AUTOMATED]: 'Automation',
  [LaunchType.MANUAL]: 'Manual',
  [LaunchType.COMPLETE]: 'Complete',
});

const ScheduleCadence = Object.freeze({
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
});

const ScheduleStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  AUTO_PAUSED: 'AUTO_PAUSED',
  EXPIRED: 'EXPIRED',
});

const ScheduleChangeType = Object.freeze({
  STATUS: 'STATUS',
  ENVIRONMENT: 'ENVIRONMENT',
  IS_SEQUENTIAL: 'IS_SEQUENTIAL',
  CONFIGURATION: 'CONFIGURATION',
  CADENCE: 'CADENCE',
  NAME: 'NAME',
});

const ScheduleFireOutcome = Object.freeze({
  FIRED: 'FIRED',
  SKIPPED_GATE_BLOCKED: 'SKIPPED_GATE_BLOCKED',
  SKIPPED_NO_CASES_FOR_TYPE: 'SKIPPED_NO_CASES_FOR_TYPE',
  SKIPPED_EMPTY_GROUP: 'SKIPPED_EMPTY_GROUP',
  SKIPPED_SAME_DAY_GUARD: 'SKIPPED_SAME_DAY_GUARD',
  GUARD_FAILED_CREDITS: 'GUARD_FAILED_CREDITS',
  GUARD_FAILED_TRIAL: 'GUARD_FAILED_TRIAL',
  GUARD_FAILED_TARGET_DELETED: 'GUARD_FAILED_TARGET_DELETED',
  GUARD_FAILED_ENV_REMOVED: 'GUARD_FAILED_ENV_REMOVED',
  DISPATCH_FAILED: 'DISPATCH_FAILED',
  WORKER_ERROR: 'WORKER_ERROR',
});

/** VARCHAR causes — not a DB enum (schema §8.4) */
const ScheduleChangeCause = Object.freeze({
  USER_PAUSED: 'USER_PAUSED',
  USER_RESUME: 'USER_RESUME',
  REPEATED_FIRE_FAILURE: 'REPEATED_FIRE_FAILURE',
  CREDITS_EXHAUSTED: 'CREDITS_EXHAUSTED',
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
  TARGET_GROUP_DELETED: 'TARGET_GROUP_DELETED',
  ENVIRONMENT_REMOVED: 'ENVIRONMENT_REMOVED',
  END_DATE_REACHED: 'END_DATE_REACHED',
  USER_EDIT: 'USER_EDIT',
});

module.exports = {
  LaunchType,
  LaunchTypeLabel,
  ScheduleCadence,
  ScheduleStatus,
  ScheduleChangeType,
  ScheduleFireOutcome,
  ScheduleChangeCause,
};
